export const zahlartenEn = {
  'zahlarten.header.title': 'Payment methods',
  'zahlarten.header.subtitle': 'Manage payment methods, their DATEV mapping and the payment channel used for incoming invoices',
  'zahlarten.header.newButton': 'New payment method',
  'zahlarten.readOnlyHint': 'View only — creating, editing, deleting or reordering requires the "Edit settings" permission.',

  'zahlarten.table.name': 'Name',
  'zahlarten.table.code': 'Code',
  'zahlarten.table.type': 'Type',
  'zahlarten.table.zahlweg': 'Payment channel',
  'zahlarten.table.zahlwegTooltip': 'How could WE (the business) settle an incoming invoice with this payment method? Controls whether it is offered when marking an incoming invoice as paid.',
  'zahlarten.table.provider': 'Provider',
  'zahlarten.table.datevAccount': 'DATEV account',
  'zahlarten.table.active': 'Active',
  'zahlarten.table.actions': 'Actions',
  'zahlarten.table.empty': 'No payment methods yet',
  'zahlarten.table.standardBadge': 'Default',
  'zahlarten.table.setZahlwegBadge': 'Set payment channel',
  'zahlarten.table.editTitle': 'Edit',
  'zahlarten.table.deleteTitle': 'Delete',

  'zahlarten.modal.editTitle': 'Edit payment method',
  'zahlarten.modal.createTitle': 'New payment method',
  'zahlarten.modal.nameLabel': 'Name *',
  'zahlarten.modal.namePlaceholder': 'e.g. PayPal',
  'zahlarten.modal.descriptionLabel': 'Description',
  'zahlarten.modal.descriptionPlaceholder': 'Optional description',
  'zahlarten.modal.typeLabel': 'Type',
  'zahlarten.modal.providerLabel': 'Provider',
  'zahlarten.modal.providerPlaceholder': 'e.g. PayPal, Klarna',

  'zahlarten.modal.zahlwegLabel': 'Payment channel for incoming invoices *',
  'zahlarten.modal.zahlwegTooltip': 'How could WE (the business) settle a supplier\'s incoming invoice with this payment method? Determines whether this payment method is selectable when marking an incoming invoice as paid. "None" is for pure sales channels (e.g. invoice purchase by our own customers, gift vouchers) — those cannot settle a liability of ours.',
  'zahlarten.modal.zahlwegPlaceholder': 'Please select …',
  'zahlarten.zahlwegOptions.kasse': 'Cash register',
  'zahlarten.zahlwegOptions.bank': 'Bank (transfer/direct debit)',
  'zahlarten.zahlwegOptions.verrechnung': 'Offsetting (cash discount, supplier credit note, …)',
  'zahlarten.zahlwegOptions.keine': 'None — pure sales channel (e.g. invoice purchase, gift voucher)',
  'zahlarten.zahlwegKurz.kasse': 'Cash register',
  'zahlarten.zahlwegKurz.bank': 'Bank',
  'zahlarten.zahlwegKurz.verrechnung': 'Offsetting',
  'zahlarten.zahlwegKurz.keine': 'None',

  'zahlarten.modal.datevAccountLabel': 'DATEV account number',
  'zahlarten.modal.datevAccountTooltip': 'Account the register books payments of this type to. Examples SKR03: 1000 = cash, 1360 = card clearing, 1400 = trade receivables (invoice purchase), 1200 = bank. SKR04: 1600 / 1460 / 1200 / 1800.',
  'zahlarten.modal.datevAccountPlaceholderInvoice': '1400 (SKR03)',
  'zahlarten.modal.datevAccountPlaceholderOther': 'e.g. 1360',
  'zahlarten.modal.datevBuKeyLabel': 'DATEV tax key',
  'zahlarten.modal.datevBuKeyPlaceholder': 'e.g. 10',

  'zahlarten.modal.invoicePaymentLabel': 'Invoice purchase (customer pays later by invoice)',
  'zahlarten.modal.invoicePaymentTooltip': "Enable when this payment method means the customer pays for the goods later by invoice (e.g. 'on account', 'net terms', 'B2B invoice'). The register then books NO revenue in the DATEV export — revenue is booked exclusively by the ERP once the invoice run happens. This avoids double revenue bookings.",
  'zahlarten.modal.invoicePaymentHint': 'The register still records the transaction in a fiscally compliant way, but books no revenue. Recommendation: DATEV account 1400 (SKR03) / 1200 (SKR04) for trade receivables.',

  'zahlarten.modal.shipBeforePaymentLabel': 'Shipping before payment received',
  'zahlarten.modal.shipBeforePaymentTooltip': 'May goods leave the building with this payment method before the money has arrived? Common for invoice purchase and cash on delivery, not for advance payment. Orders that may not ship do not even appear on the handheld for picking. Pickup orders are unaffected — payment happens at hand-over.',
  'zahlarten.shipBefore.unsetTitle': 'Not set',
  'zahlarten.shipBefore.unsetText': 'The value taken over from JTL applies. Without a JTL value, unpaid goods stay blocked until the order is marked as paid.',
  'zahlarten.shipBefore.allowedTitle': 'Allowed',
  'zahlarten.shipBefore.allowedText': 'Goods may ship even though payment has not been received yet — for invoice purchase, cash on delivery, or customers with payment terms.',
  'zahlarten.shipBefore.notAllowedTitle': 'Not allowed',
  'zahlarten.shipBefore.notAllowedText': 'Only once the money has arrived. The order will not appear in picking until then.',

  'zahlarten.modal.onlineCheckoutLabel': 'Offer in online checkout',
  'zahlarten.modal.onlineCheckoutTooltip': "Guests can choose this payment method during a scan-to-order purchase. With provider 'paypal', the guest pays online immediately — the order only reaches the register once payment is confirmed. Without a provider, payment happens at the register (e.g. 'pay on pickup').",
  'zahlarten.modal.onlineCheckoutHint': 'For PayPal, also enter provider {{code}} and set DATEV account 1210 (SKR03) / 1810 (SKR04).',

  'zahlarten.modal.shopLabel': 'Offer in web shop',
  'zahlarten.modal.shopTooltip': 'Applies to the connected web shop — independent of the online checkout above, which controls self-ordering by scanning in-store.',
  'zahlarten.modal.shopHint': 'Payment methods with a provider (PayPal, Stripe, Mollie) need credentials in the shop and are set up there — they are not transferred from here.',

  'zahlarten.modal.conditionsHeading': 'Payment terms',
  'zahlarten.modal.paymentTermsLabel': 'Payment term (days)',
  'zahlarten.modal.paymentTermsPlaceholder': 'e.g. 14',
  'zahlarten.modal.discountPercentLabel': 'Cash discount (%)',
  'zahlarten.modal.discountPercentPlaceholder': 'e.g. 2',
  'zahlarten.modal.discountDaysLabel': 'Cash discount period (days)',
  'zahlarten.modal.discountDaysPlaceholder': 'e.g. 10',
  'zahlarten.modal.orderConfirmationTextLabel': 'Text for order confirmation',
  'zahlarten.modal.orderConfirmationTextPlaceholder': 'e.g. Payable within 14 days, 2% discount if paid within 10 days',
  'zahlarten.modal.invoiceTextLabel': 'Text for invoice',
  'zahlarten.modal.invoiceTextPlaceholder': 'e.g. Please transfer the amount within 14 days',

  'zahlarten.modal.activeLabel': 'Active',
  'zahlarten.modal.defaultLabel': 'Default payment method',
  'zahlarten.modal.cancelButton': 'Cancel',
  'zahlarten.modal.saveButton': 'Save',
  'zahlarten.modal.createButton': 'Create',

  'zahlarten.errors.nameRequired': 'Name is required',
  'zahlarten.errors.zahlwegRequired': 'Payment channel is required — please select what this payment method can settle an incoming invoice with.',
  'zahlarten.errors.saveFailedPrefix': 'Failed to save: ',
  'zahlarten.errors.toggleFailedPrefix': 'Failed to toggle: ',
  'zahlarten.errors.deleteFailedPrefix': 'Failed to delete: ',
  'zahlarten.errors.loadFailed': 'Failed to load payment methods',
  'zahlarten.errors.unknown': 'Unknown error',
  'zahlarten.errors.forbidden': 'This action requires the "Edit settings" permission.',

  'zahlarten.delete.title': 'Delete payment method?',
  'zahlarten.delete.text': 'Do you really want to delete this payment method? This action cannot be undone.',
  'zahlarten.delete.cancelButton': 'Cancel',
  'zahlarten.delete.confirmButton': 'Delete',

  'zahlarten.types.prepayment': 'Advance payment',
  'zahlarten.types.invoice': 'Invoice',
  'zahlarten.types.online': 'Online payment',
  'zahlarten.types.cash': 'Cash',
  'zahlarten.types.other': 'Other',

  'zahlarten.myPortal.sectionTitle': 'Payment channels for incoming invoices',
  'zahlarten.myPortal.sectionText': 'Which payment methods are offered when an incoming invoice (supplier invoice) is marked as paid — and what it was actually paid with (cash register, bank, offsetting).',

  'zahlarten.configSection.readOnlyHint': 'Changing this requires the "Edit settings" permission.',
  'zahlarten.configSection.forbidden': 'This action requires the "Edit settings" permission.',
};
